import { render, staticRenderFns } from "./detailPop.vue?vue&type=template&id=e9b74142&scoped=true&"
import script from "./detailPop.vue?vue&type=script&lang=js&"
export * from "./detailPop.vue?vue&type=script&lang=js&"
import style0 from "./detailPop.vue?vue&type=style&index=0&id=e9b74142&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b74142",
  null
  
)

export default component.exports